<template>
<div>

<DialogBox :settings="settings" @show="initialiseDialog">

    <template slot="header">
        <v-menu bottom left v-if="linkedKeys.length">
            <template v-slot:activator="{ on }">
            <v-btn class="mt-1"icon v-on="on" dark>
                <v-icon>more_vert</v-icon>
            </v-btn>
            </template>
            <v-list> 
                <v-list-item @click="unlinkAllFiles"> 
                    <v-list-item-title>Unlink All Files</v-list-item-title>
                </v-list-item>   
            </v-list>
        </v-menu>
    </template>

    <!-- Right Button Panel -->
    <div slot="sidebar" style="float:right;width:150px;" class="pa-2">
        <div style="text-align:center;padding:4px;" class="grey--text">
            {{this.selectedKeys.length || 'None'}} selected
            <a v-if="this.selectedKeys.length" @click.prevent="selectedKeys = []" href >Clear</a>
        </div>
        <div style="padding:0px 0px 5px 26px" class="grey--text">
            {{this.linkedKeys.length || 'None'}} linked
            <a v-if="this.linkedKeys.length" @click.prevent="selectLinkedKeys" href >Select</a>
        </div>        
        <template v-if="this.selectedKeys.length" >
            <v-btn class="mt-1" v-if="linkButtonVisible" style="width:90%" @click="linkSelectedFiles">Link</v-btn>
            <v-btn class="mt-1" v-if="selectedLinkedKeys.length" style="width:90%" @click="unlinkSelectedFiles">Un-link</v-btn>
            <v-btn class="mt-1" style="width:90%" @click="emailFiles">Email</v-btn><br/>
        </template>
        <template v-if="this.selectedKeys.length == 1" >
            <v-btn class="mt-1" style="width:90%" @click="renameFile">Rename</v-btn>
            <v-btn class="mt-1" style="width:90%" @click="copyLink">Copy Link</v-btn>
        </template>
        <UploadWrapper @select="uploadFiles">
            <v-btn class="mt-1  mr-1 mb-1" style="width:90%" @click="" >Upload</v-btn>
        </UploadWrapper>
        <template v-if="this.selectedKeys.length > 1 && !isMobile" >
            <v-btn class="mt-1" style="width:90%" @click="downloadZip">Save to Zip</v-btn>
        </template>        
    </div>

    <!-- List -->
    <div style="padding-right:10px;padding-left:10px;min-height:400px">

        <!-- <div style="width:100%;padding-left:72px"> -->
            <input ref="search" type="text" v-model="search" placeholder="Search..." class="quick-input no-focus" style="width:100%;margin-top:8px;" />
        <!-- </div> -->

        <v-list>
            <v-list-item class="blue-select" :class="{'selected':isSelected(file.key)}" v-for="file in filesDisplay" 
            @click.exact="selectSingle(file)"
            @click.meta="selectMulti(file)" @click.ctrl="selectMulti(file)"
            @click.shift="selectRange(file)"
            :title="file.title + ' (' + file.name + ')'"
            :key="file.key">
                <v-list-item-avatar>
                    <v-btn class="mt-1 primary" icon v-if="isLinked(file.key)">
                        <v-icon color="white">insert_link</v-icon>
                    </v-btn>
                    <v-icon large color="grey" v-else>{{fileIconString(file)}}</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                <v-list-item-title>
                    {{getFileName(file)}} <span class="light-text small-text">{{file.stamp.date | shortDate}}</span>
                </v-list-item-title>
                <v-list-item-subtitle>
                    <span :title="file.originalName">{{file.originalName}}</span>  
                </v-list-item-subtitle>
                
                </v-list-item-content>

                <v-list-item-action>
                    <div v-if="file.loading" style="display:flex">
                        <span style="color:#888">{{file.progress}}%&nbsp;</span>
                        <v-progress-circular style="float:right" :size="20" :width="2" indeterminate class="grey--text"></v-progress-circular>
        
                    </div>
                    <template v-else>
                        <!-- <DocumentView :url="file.value" :type="file.type" >  -->
                        <a :ref="'download' + file.key" :href="file.value" class="transparent" target="_blank">      
                            <v-btn @xxclick.stop class="mt-1 grey--text" icon>
                                <v-icon>mdi-file-image</v-icon>
                            </v-btn>       
                        </a>
                        <!-- </DocumentView> -->
                    </template>
                </v-list-item-action>

            </v-list-item>
        </v-list>

  
        </div>

        <template slot="footer" v-if="this.selectedKeys.length">
            <DeleteButton @delete="deleteSelectedFiles" />
        </template>

</DialogBox>

<EmailDialog :settings="emailDialog.settings" :email="emailDialog.email" @sent=""/>
<InputDialog :settings="inputDialog.settings" @save="changeFileName"/>


</div>
</template>

<script>
 
import DialogBox from '../ui-elements/DialogBox'
import InputDialog from '../ui-elements/InputDialog'
import UploadWrapper from '../ui-elements/UploadWrapper'
import ElementHelpers from '../helpers/ElementHelpers'
import Utilities from '../helpers/Utilities'
import ListHelpers from '../helpers/ListHelpers'
import SelectionHelpers from '../helpers/SelectionHelpers'
import DataHelpers from '../helpers/DataHelpers'
import DeleteButton from '../ui-elements/DeleteButton'
import EmailDialog from '../ui-elements/EmailDialog'
import ArrayHelpers from '../helpers/ArrayHelpers'
import FileHelpers from '../helpers/FileHelpers'
import AlertHelpers from '../helpers/AlertHelpers'
import JSZip from 'jszip'
import saveAs from 'file-saver'
import clipboard from 'clipboard-js'
import ToolbarSearch from '../ui-elements/ToolbarSearch'
import DocumentView from '../ui-elements/DocumentView'


export default {
    data() {
        return {
            search: '',
            selectedKeys: [],
            emailDialog: {

                email: {
                    to: null,
                    cc: null,
                    bcc: null,
                    subject: null,
                    body: '',
                    attachments: []
                },
                settings: {
                    visible: false,
                    group: 'Files',
                    template: 'Send Files'
                }
            },            
            inputDialog: {
                settings: {
                    visible: false,
                    description: 'New name',
                    title: "Rename File",
                    default: null,
                }
            },            
        }
    },
    components: {
        DialogBox,
        UploadWrapper,
        DeleteButton,
        EmailDialog,
        InputDialog,
        ToolbarSearch,
        DocumentView,
    },

    props: {
        element: Object,
        settings: Object,
        files: Array,

    },

    computed: {

        linkedKeys() {
            if(!this.element)
                return []

            const newKeys = this.element.linkedFileKeys || []

            //todo:remove later
            const oldKeys = ElementHelpers.filesForElement(this.element, this.elements).map(o => o.key)
            oldKeys.forEach(key => {
                ArrayHelpers.pushUnique(key, newKeys)
            })

            return newKeys
        },

        elements() {
            return this.$store.getters.elements
        },

        linkedFiles() {
            return this.files.filter(file => this.linkedKeys.indexOf(file.key) > -1)
        },

        unlinkedFiles() {
            return this.files.filter(file => this.linkedKeys.indexOf(file.key) == -1)
        },

        filesDisplay () {
            let allFiles = []      
            allFiles = [...this.linkedFiles, ...this.unlinkedFiles].filter(file => {
                if(!this.search)
                    return true

                return file.fileName.toLowerCase().indexOf(this.search.toLowerCase() ) > -1
            })
            return allFiles
        },

        selectedFiles() {
            return SelectionHelpers.getSelectedItems(this.filesDisplay, this.selectedKeys)
        },

        selectedLinkedKeys() {
            return this.selectedKeys.filter(key => this.linkedKeys.indexOf(key) > -1)
        },

        selectedUnlinkedKeys() {
            return this.selectedKeys.filter(key => this.linkedKeys.indexOf(key) == -1)
        },

        linkButtonVisible() {
            return (this.element && this.selectedUnlinkedKeys)
        },

        isMobile () {
            return Utilities.isMobile()
        },        
    },


    methods: {
        downloadZip() {
            AlertHelpers.showAlert('Downloading...See below')
            const zip = new JSZip()
            const folder = zip.folder('files')
            this.selectedFiles.forEach((file)=> {
                
                const blobPromise = fetch(file.value).then(r => {
                    if (r.status === 200) return r.blob()
                    return Promise.reject(new Error(r.statusText))
                })
                
                const name = FileHelpers.fileNameFromStoragePath(file.originalName)
                folder.file(name, blobPromise)
            })

            zip.generateAsync({type:"blob"})
                .then(blob => {
                    saveAs(blob, 'documents_download.zip')
                }).catch(e => console.log(e))
        },
        getFileName(file) {
            return file.fileName ||
                file.name.replace(/\_/g, ' ')
        },
        renameFile() {
            let selectedFile = this.selectedFiles[0]
            //can remove name later. all should have fileName
            this.inputDialog.settings.default = selectedFile.fileName || selectedFile.name
            this.inputDialog.settings.file = selectedFile
            this.inputDialog.settings.visible = true
        },
        copyLink() {
            let selectedFile = this.selectedFiles[0]
            clipboard.copy({'text': selectedFile.value})
            AlertHelpers.showAlert('Link copied to clipboard')
        },

        changeFileName(newName, settings) {
            if(!newName)
                return

            let newFile = {
                key: settings.file.key,
                fileName: newName,
            }
            this.saveElement(newFile)
        },

        emailFiles() {
            this.emailDialog.email.attachments = this.selectedFiles
            this.emailDialog.settings.visible = true
        },

        fileIconString(file) {

            if(!file || !file.originalName)
                return 'library_books'

            let fileExtension = file.originalName.split('.').pop().toLowerCase()

            if(fileExtension == 'pdf')
                return 'mdi-file-pdf-outline'
            else if(fileExtension == 'doc')
                return 'perm_media'
            else if(fileExtension == 'jpg' || fileExtension == 'gif' || fileExtension == 'png')
                return 'mdi-image-outline'
            else
                return 'library_books'
        },

        uploadFiles(files) {
            this.$store.dispatch('uploadFiles', {files,'element':this.element})
        },

        selectLinkedKeys() {
            this.selectedKeys.splice(0, this.selectedKeys.length)
            this.linkedKeys.forEach(key => {
                this.selectedKeys.push(key)
            })
        },

        //Linking files

        linkSelectedFiles() {
            this.linkSelectedKeys()
            this.changeSelectedFileNames()
        },

        linkSelectedKeys() {
            let newLinkedKeys = [...this.linkedKeys]
            this.selectedKeys.forEach(key => {
                ArrayHelpers.pushUnique(key, newLinkedKeys)
            })            
            let newElement = {...this.element}
            newElement.linkedFileKeys = newLinkedKeys
            
            this.saveElement(newElement)
        },

        changeSelectedFileNames() {
            
            const targetFileName = this.element.targetName
            if(!targetFileName)
                return
            this.selectedFiles.forEach(file => {
                if(file.name != targetFileName) {
                    file.name = targetFileName
                    this.saveElement(file)
                }
            })
        },

        unlinkSelectedFiles() {
            let newLinkedKeys = [...this.linkedKeys]
            this.selectedKeys.forEach(key => {
                ArrayHelpers.deleteItem(key, newLinkedKeys) 
                
                //todo: this can be removed...old way to do links...
                // console.log('*** To remove from FileDialog > unlinkSelectedFiles')
                // let ref = DataHelpers.getTransactionRef().child('elements').child(key)
                // ref.update({'triggerElementKey':null, name: 'general_file'}) 
                
                let obj = {
                    key: key,
                    triggerElementKey: null, //can remove later
                    name: 'general_file'
                }
                this.saveElement(obj)               
            }) 
                   
            let newElement = {...this.element}
            newElement.linkedFileKeys = newLinkedKeys
            
            this.saveElement(newElement)
        },

        unlinkAllFiles() {
            let newElement = {...this.element}
            newElement.linkedFileKeys = []
            this.saveElement(newElement)
        },

        // *****

        async deleteSelectedFiles() {
            if(await this.$root.$confirm('Delete', 'Delete these files completely?', { color: 'red' }) == true) {
                this.unlinkSelectedFiles()
                this.selectedFiles.forEach(file => {
                    this.deleteElement(file)           
                })   
                this.selectedKeys = []
            }
        },

        deleteElement(element) {
            this.$store.dispatch('deleteElement', element)
        },
        
        selectSingle(file) {
            
            
            //.pop()
            console.log('Calculated file name is', FileHelpers.fileNameFromStoragePath(file.value))

            let path = DataHelpers.getTransactionRef().toString() + `/elements/${file.key}`
            console.log('File Clicked', path)

            SelectionHelpers.selectSingle(file.key, this.selectedKeys)
        },
        selectMulti(file) {
            console.log('ctrlclicked', file.key)
            SelectionHelpers.selectMulti(file.key, this.selectedKeys)
        },
        selectRange(file) {
            console.log('shiftclicked', file.key)
            SelectionHelpers.selectRange(file.key, this.selectedKeys, this.filesDisplay.map(o => o.key))
        },
        isSelected(fileKey) {
            return (this.selectedKeys.indexOf(fileKey) > -1)
        },
        isLinked(fileKey) {
            return (this.linkedKeys.indexOf(fileKey) > -1)
        },
        saveElement(element) {
            this.$store.dispatch('saveElement', element)
        },        
        initialiseDialog() {
            this.selectedKeys = []
            this.search = ''
            Utilities.focus(this, 'search')
        }
    },

    created() {
        if(this.element)
            this.settings.title = 'Files for ' + this.element.title  
    },

    // watch: {
    //     'settings.visible': {
    //         handler: function(newVal) {
    //             if(newVal)
    //                 initiali
    //             Utilities.focus(this, 'search')
    //         }
    //     }
    // }
}
</script>

<style scoped>
.blue-select {
    border:solid 1px transparent;
}
.blue-select.selected {
    /* background-color: rgb(187, 222, 255); */
    background-color: #E3F2FD;
    border: solid 1px rgb(112, 184, 255);
    box-shadow: 0 0 5px rgb(48, 132, 216);
}

   
</style>




// WEBPACK FOOTER //
// FileDialog.vue?20abf92a